import { useRouter } from 'next/router'
import TabBar from './TabBar'

type Category = { link: string; title: string }

const tabs: Record<string, Category> = {
  services: { link: '/services', title: 'Services' },
  science: { link: '/services/science', title: 'Science' },
  business: { link: '/services/business', title: 'Business' },
}

const ServicesNavigation: React.FC = () => {
  const router = useRouter()
  const current = Object.keys(tabs).find(
    (k) => router.pathname === tabs[k].link,
  )

  const switchCategory = (cat: Category) => {
    router.push(cat.link)
  }

  return (
    <div className="my-8">
      <TabBar tabs={tabs} onSet={switchCategory} current={current}></TabBar>
    </div>
  )
}

export default ServicesNavigation
